<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">用户管理>用户列表>用户列表</div>
		<div class="waititle" style="font-weight: bold;">
			<div class="blue" />
			用户列表
		</div>
		<div class="input_list">
			<div class="input_one" style="display: flex;">
				<div style="display: flex;flex: 1;">
					<div class="input_one_wen">关键字</div>
					<el-select style="width:100px;" size="small" v-model="filter.key" placeholder="关键字">
						<el-option v-for="item in keyoptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<el-input v-model="filter.keyContent" @keydown.enter.native="getlist(1)" size="small"
						placeholder="输入内容" style="width: 300px;"></el-input>
						
				</div>
				<div style="display:flex;float:right">
					<el-button size="small" @click="onload">
						<i class="el-icon-refresh"></i> 刷 新
					</el-button>
					<el-button type="info" size="small" @click="expporext()" >
						导出用户数据
					</el-button>
				</div>
			</div>
			<div class="input_one">
				<div class="input_one_wen">标签名称</div>
				<el-select style="width:150px;" size="small" v-model="filter.label" placeholder="请选择标签名称">
					<el-option v-for="item in knameoption" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<div class="input_one_wen" style="margin-left: 30px;">用户身份</div>
				<el-select style="width:150px;" size="small" v-model="filter.isMember" placeholder="请选择" clearable>
					<el-option v-for="item in userident" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
			</div>
			<div class="input_one">
				<div class="input_one_wen">最近消费时间</div>
				<el-date-picker style="width:210px;" size="small" value-format="yyyy-MM-dd"
					v-model="filter.latestConStartTime" type="date" placeholder="请选择日期"
					@change="changeDiabale()"></el-date-picker>
				<div style="width:35px;text-align: center;line-height: 30px;">至</div>
				<el-date-picker style="width:210px;" size="small" value-format="yyyy-MM-dd"
					v-model="filter.latestConEndTime" type="date" placeholder="请选择日期"
					@change="changeDiabale()"></el-date-picker>
			</div>
			<div class="input_one">
				<div class="input_one_wen">R最近消费间隔</div>
				<el-input type="number" placeholder="天" min="0" size="small" v-model="filter.keyR" style="width:80px;"
					:disabled="disabled"></el-input>
				<div style="width:35px;text-align: center;line-height: 30px;">至</div>
				<el-input type="number" placeholder="天" min="0" size="small" v-model="filter.keyRup" style="width:95px;"
					:disabled="disabled"></el-input>
				<div class="input_one_wen01">F消费频率</div>
				<el-input type="number" placeholder="次·" min="0" size="small" v-model="filter.keyF" style="width:80px;"
					:disabled="disabled"></el-input>
				<div style="width:35px;text-align: center;line-height: 30px;">至</div>
				<el-input type="number" placeholder="次" min="0" size="small" v-model="filter.keyFup" style="width:80px;"
					:disabled="disabled"></el-input>
				<div class="input_one_wen01">M消费金额</div>
				<el-input type="number" placeholder="元·" min="0" size="small" v-model="filter.keyM"
					style="width:80px;margin-left: 10px;" :disabled="disabled"></el-input>
				<div style="width:35px;text-align: center;line-height: 30px;">至</div>
				<el-input type="number" placeholder="元" min="0" size="small" v-model="filter.keyMup" style="width:80px;"
					:disabled="disabled"></el-input>
				<div>
					<el-button type="primary" style="margin-left: 10px; " @click="getlist(1)"
						size="small">筛选</el-button>
					<el-button type="text" size="small" @click="clearlist">清空所有选项</el-button>
				</div>
			</div>
		</div>
		<div class="usertable" v-loading="loading">
			<el-table :header-cell-style="{ background: '#F2F2F4' }" ref="multipleTable" :data="list"
				tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="id" label="ID" width="90"></el-table-column>
				<el-table-column label="昵称">
					<template slot-scope="scope">
						{{scope.row.nickName?scope.row.nickName:"无"}}
					</template>
				</el-table-column>
				<el-table-column label="性别" width="80">
					<template slot-scope="scope">
						{{scope.row.gender?scope.row.gender:"无"}}
					</template>
				</el-table-column>
				<el-table-column label="手机号" width="115">
					<template slot-scope="scope">
						{{scope.row.telphone?scope.row.telphone:"无"}}
					</template>
				</el-table-column>
				<el-table-column prop="storeNames" label="消费门店">
					<template slot-scope="scope">
						{{scope.row.storeNames?scope.row.storeNames:"无"}}
					</template>
				</el-table-column>
				<el-table-column prop="orderTotal" label="生熟客" width="80">
					<template slot-scope="scope">
						{{ scope.row.orderTotal|userTypeFormat() }}
					</template>
				</el-table-column>
				<el-table-column prop="orderTotal" label="订单数" width="80">
					<template slot-scope="scope">
						{{ scope.row.orderTotal != null ?scope.row.orderTotal :0 }}
					</template>
				</el-table-column>
				<el-table-column label="消费总额" width="100">
					<template slot-scope="scope">
						￥{{ scope.row.consumptionTotal != null ?scope.row.consumptionTotal.toFixed(2) :"0.00" }}
					</template>
				</el-table-column>
				<!-- <el-table-column prop="couponTotal" label="已有券量" width="100" center></el-table-column> -->
				<!-- 				<el-table-column prop="isMeber" label="会员" width="80px" center>
					<template slot-scope="scope">
						{{scope.row.isMeber=="1"?"会员":"普通用户"}}
					</template>
				</el-table-column> -->
				<el-table-column prop="integral" label="已有积分 " width="100" center></el-table-column>
				<el-table-column prop="addTime" label="注册时间" width="160"></el-table-column>
				<el-table-column prop="keyR" label="最近交易间隔(R)" width="110px" align="center"></el-table-column>
				<el-table-column prop="keyF" label="消费频率(F)" width="80px" align="center"></el-table-column>
				<el-table-column prop="keyM" label="消费金额(M)" width="80px" align="center"></el-table-column>
				<el-table-column label="最近消费时间 " width="160">
					<template slot-scope="scope">
						{{scope.row.latestConTime?scope.row.latestConTime:"无"}}
					</template>
				</el-table-column>
				<el-table-column width="150" label="操作">
					<template slot-scope="scope">
						<el-button type="text"
							@click="dialog_tui = true,getCouponList(scope.row.id,scope.row.nickName,scope.row.telphone)">添加券</el-button>
						<el-button type="text" @click="goshow(scope.row.id)">详情</el-button>
						<!-- <el-button type="text" @click="stickl(scope.row.id)">贴标签</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="pagescg">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="filter.page" :page-sizes="[10, 20, 30, 50]" :page-size="filter.size"
					layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
				</el-pagination>
			</div>
		</div>
		<el-dialog :visible.sync="addjuan" width="50%">
			<div class="waititle" style="font-weight: bold;margin-top: -40px;">
				<div class="blue" />
				添加券/券包
			</div>
			<div style="display: flex;">
				<el-input style="width:281px;" v-if="juanactiveName=='a'" v-model="juanname" size="small"
					placeholder="请输入优惠券名称" />
				<el-input style="width:281px;" v-if="juanactiveName=='b'" v-model="juanbname" size="small"
					placeholder="请输入券包名称" />
				<el-button type="primary" size="small" style="margin-left: 10px;" @click="getjuan">搜索</el-button>
			</div>
			<div style="margin-top: 20px;">
				<el-tabs type="border-card" v-model="juanactiveName">
					<el-tab-pane name="a" label="券">
						<el-table height="250" :data="juantable" style="width: 100%">
							<el-table-column label="选择">
								<template slot-scope="scope">
									<div>
										<el-checkbox style="width:18px;overflow: hidden;margin-left:8px;"
											v-model="juango.juan" :label="scope.row.id"></el-checkbox>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="title" label="名称"></el-table-column>
							<el-table-column prop="couponType" label="类型"></el-table-column>
							<el-table-column prop="storeListName" label="适用范围"></el-table-column>
							<el-table-column prop="content" label="券内容"></el-table-column>
							<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
							<el-table-column prop="getNumScaleTotalNum" label="已领取/券总量"></el-table-column>
						</el-table>
						<div class="juanpages">
							<el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
								:current-page="juanfilter.page" :page-sizes="[5, 10, 15, 20]"
								:page-size="juanfilter.size" layout="total, sizes, prev, pager, next, jumper"
								:total="juanfilter.total">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane name="b" label="券包">
						<el-table height="250" :data="juanbaotable" style="width: 100%">
							<el-table-column label="选择">
								<template slot-scope="scope">
									<div style="width: 50px;overflow: hidden;">
										<el-checkbox style="width:18px;overflow: hidden;margin-left:8px;"
											v-model="juango.juans" :label="scope.row.id"></el-checkbox>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="名称"></el-table-column>
							<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
							<el-table-column prop="getNumScaleTotalNum" label="已领取/券总量"></el-table-column>
						</el-table>
						<div class="juanpages">
							<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
								:current-page="juanbfilter.page" :page-sizes="[5, 10, 15, 20]"
								:page-size="juanbfilter.size" layout="total, sizes, prev, pager, next, jumper"
								:total="juanbfilter.total">
							</el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addjuan=false">取 消</el-button>
				<el-button type="primary" @click="fasongjuan">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="添加人群" :visible.sync="sticklabel" width="30%">
			<el-checkbox-group v-if="newknameoption.length>0" v-model="labelchecks" style="margin-top: -25px;">
				<div v-for="i in newknameoption" :key="i.value" style="margin-top:10px;">
					<el-checkbox style="transform: scale(1.2);width: 25px;" class="checkeds"
						:label="i.value">{{i.label}}</el-checkbox>
				</div>
			</el-checkbox-group>
			<div v-else class="nolabel">
				<p>暂无可贴标签</p>
				<p>需新建用户群后选择</p>
			</div>
			<span style="margin-left: 35%;">
				<el-button @click="sticklabel = false">取 消</el-button>
				<el-button type="primary" @click="stickladd">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 发送券弹窗 -->
		<el-dialog :visible.sync="dialog_tui" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1;">选择优惠券</div>
				<span style="margin-left: 35%;">
					<el-button @click="dialog_tui = false">取 消</el-button>
					<el-button type="primary" @click="sendCoupon()">确 定</el-button>
				</span>
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponList" tooltip-effect="dark" style="width: 100%">
					<el-table-column label="券ID">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="radio"></el-radio>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="title" label="名称"></el-table-column>
					<el-table-column prop="couponType" label="类型"></el-table-column>
					<el-table-column prop="storeNames" label="适用范围">
						<template scope="scope">
							<div style="overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
								{{scope.row.storeName==null?'全部门店':scope.row.storeName}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
					<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
					<el-table-column prop="useNum" label="已使用"></el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange02" @current-change="handleCurrentChange02"
						:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="query.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		url
	} from "../../utils/index.js"
	export default {
		data() {
			return {
				loading: false,
				url: url(),
				juango: {
					juan: [],
					juans: []
				},
				dialog_tui: false,
				couponList: [],
				query: {
					overStatus: "1",
					name: "",
					status: -1,
					type: -1,
					page: 1,
					size: 10,
					total: 0,
				},
				radio: "",
				templateSelection: [],
				senddata: {
					userId: "",
					nickname: "",
					telphone: "",
					couponId: ""
				},
				addjuan: false,
				juanactiveName: "a",
				juanname: "",
				juanbname: "",
				juantable: [],
				juanbaotable: [],
				juanfilter: {
					page: 1,
					size: 5,
					total: 0
				},
				juanbfilter: {
					page: 1,
					size: 5,
					total: 0
				},
				listchecked: [],
				sendcoupon: false, //发送优惠券
				//发送优惠券里面的标签页
				activeName: "first",
				sticklabel: false, //贴标签
				list: [],
				disabled: true, //控制三个值是否禁用
				filter: {
					total: 0,
					addConMonDown: "", //消费金额头
					addConMonUp: "", //消费金额尾
					keyR: "", //最近消费间隔
					keyRup: "",
					keyF: "", //消费频率
					keyFup: "",
					keyM: "", //消费金额
					keyMup: "",
					key: "id", //关键字key
					keyContent: "", //关键字内容
					label: "", //标签
					latestConEndTime: "", //最近消费时间尾
					latestConStartTime: "", //最近消费时间头
					page: 1,
					purchaseTimesDown: "", //购买次数头
					purchaseTimesUp: "", //购买次数尾
					size: 10,
					userToken: "",
					isMember: "",
				},
				// 关键字下拉框
				keyoptions: [{
						label: "id",
						value: "id"
					},{
						label: "昵称",
						value: "昵称"
					},{
						label: "手机号",
						value: "手机号"
					}
				],
				//标签名称下拉框
				knameoption: [],
				//贴标签可选标签
				newknameoption: [],
				//贴标签选中框
				labelchecks: [],
				stuckid: "",
				//用户身份下拉框
				userident: [{
						label: "普通用户",
						value: 0
					},{
						label: "会员",
						value: 1
					},{
						label: "发型师",
						value: 2
					}
				],
				times: '',
			};
		},
		filters: {
			userTypeFormat(val) {
				let str = '无消费';
				if (val == 1) {
					str = '首次消费';
				} else if (val > 1 && val < 4) {
					str = '生客';
				} else if (val > 3 && val < 5) {
					str = '熟客';
				} else if (val > 4) {
					str = '深度熟客';
				}
				return str;
			}
		},
		mounted() {
			this.getlist()
			// 获取标签名称列表
			this.getlabelname()
			this.getjuan()
		},
		methods: {
			//发送券
			fasongjuan() {
				if (this.listchecked.length == 0) {
					return this.$message.error("请选择收券人")
				}
				if (this.juango.juan.length == 0 && this.juango.juans.length == 0) {
					return this.$message.error("请选择优惠券")
				}
				let arr = {
					userId: this.listchecked,
					couponIds: this.juango.juan,
					couponPackageIds: this.juango.juans
				}
				this.$http.post("user/sendCoupon", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("发送成功")
						this.listchecked = []
						this.juango.juan = []
						this.juango.juans = []
						this.addjuan = false
						this.getlist()
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			getjuan() {
				this.$http.get("dUserOperate/coupon", {
					params: {
						page: this.juanfilter.page,
						size: this.juanfilter.size,
						name: this.juanname
					}
				}, {
					emulateJSON: true
				}).then(function(res) {
					if (res.body.code == 200) {
						this.juantable = res.body.data
						this.juanfilter.total = res.body.total
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
				let arr = {
					pageNum: this.juanbfilter.page,
					pageSize: this.juanbfilter.size,
					name: this.juanbname
				}
				this.$http.get("dUserOperate/couponPackage", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == 200) {
						this.juanbaotable = res.body.data
						this.juanbfilter.total = res.body.total
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			//贴标签
			stickl(id) {
				this.stuckid = id
				this.$http.get("user/toSetLabel", {
					params: {
						id: id
					}
				}, {
					emulateJSON: true
				}).then(function(res) {
					if (res.body.code == 200) {
						this.newknameoption = []
						for (let i in res.body.data) {
							let a = {
								label: res.body.data[i].labelName,
								value: res.body.data[i].id
							}
							this.newknameoption.push(a)
						}
						this.sticklabel = true
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			//确认添加标签
			stickladd() {
				var data = "?userId=" + this.stuckid + "&labelIds=" + this.labelchecks;
				this.$http.get("user/setLabel" + data).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("贴标签成功")
						this.sticklabel = false
						this.getlist()
					} else {
						this.$message.error("贴标签失败")
					}
				})
			},
			send() {
				console.log(this.listchecked)
			},
			// 清空所有参数
			clearlist() {
				this.filter.addConMonDown = ""
				this.filter.addConMonUp = ""
				this.filter.keyR,
				this.filter.keyRup,
				this.filter.keyF,
				this.filter.keyFup,
				this.filter.keyM,
				this.filter.keyMup,
				this.filter.key = "昵称"
				this.filter.keyContent = ""
				this.filter.label = ""
				this.filter.latestConStartTime = ""
				this.filter.latestConEndTime = ""
				this.filter.purchaseTimesDown = ""
				this.filter.purchaseTimesUp = ""
				this.filter.userToken = ""
				this.filter.isMember = ""
				this.getlist()
			},
			//获取标签名称
			getlabelname() {
				this.$http.get("user/label").then(function(res) {
					if (res.body.code == 200) {
						this.knameoption = []
						for (let i in res.body.data) {
							let a = {
								label: res.body.data[i].labelName,
								value: res.body.data[i].id
							}
							this.knameoption.push(a)
						}
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			//导出内容
			expporext() {
				if (this.filter.latestConEndTime == "") {
					this.filter.latestConEndTime = ""
					this.latestConStartTime = ""
				}
				if (this.latestConStartTime == "") {
					this.filter.latestConEndTime = ""
					this.latestConStartTime = "null"
				}
				var urls = "?addConMonDown=" + this.filter.addConMonDown +
					"&addConMonUp=" + this.filter.addConMonUp +
					"&key=" + this.filter.key +
					"&keyContent=" + this.filter.keyContent.trim() +
					"&label=" + this.filter.label +
					"&latestConEndTime=" + this.filter.latestConEndTime +
					"&latestConStartTime=" + this.filter.latestConStartTime +
					"&page=" + this.filter.page +
					"&purchaseTimesDown=" + this.filter.purchaseTimesDown +
					"&purchaseTimesUp=" + this.filter.purchaseTimesUp +
					"&size=" + this.filter.size +
					"&total=" + this.filter.total +
					"&userToken=" + this.filter.userToken +
					"&isMember=" + this.filter.isMember;
				if (this.filter.keyR != '' && this.filter.keyR != undefined) {
					urls = urls + "&keyR=" + this.filter.keyR
				}
				if (this.filter.keyRup != '' && this.filter.keyRup != undefined) {
					urls = urls + "&keyRup=" + this.filter.keyRup
				}
				if (this.filter.keyF != '' && this.filter.keyF != undefined) {
					urls = urls + "&keyF=" + this.filter.keyF
				}
				if (this.filter.keyFup != '' && this.filter.keyFup != undefined) {
					urls = urls + "&keyFup=" + this.filter.keyFup
				}
				if (this.filter.keyM != '' && this.filter.keyM != undefined) {
					urls = urls + "&keyM=" + this.filter.keyM
				}
				if (this.filter.keyMup != '' && this.filter.keyMup != undefined) {
					urls = urls + "&keyMup=" + this.filter.keyMup
				}
				window.location.assign(this.url + "user/exporDEvaluate" + urls);
			},
			//刷新当前页面
			onload() {
				location.reload()
			},
			//获取券2021.01.07
			handleSizeChange02(val) {
				this.query.size = val;
				this.getCouponList(this.senddata.userId, this.senddata.nickname, this.senddata.telphone);
			},
			handleCurrentChange02(val) {
				this.query.page = val
				this.getCouponList(this.senddata.userId, this.senddata.nickname, this.senddata.telphone);
			},
			pagechange() {
				this.query.size = 10
				this.query.page = 1
				this.getCouponList(this.senddata.userId, this.senddata.nickname, this.senddata.telphone);
			},
			getCouponList(id, name, telphone) {
				var query = "?pageNum=" + this.query.page + "&pageSize=" + this.query.size + "&overStatus=" + this.query
					.overStatus + "&name=" + this.query.name;
				if (this.query.status != -1) query += "&status=" + this.query.status;
				if (this.query.type != -1) query += "&type=" + this.query.type;
				this.$http.get("dCoupon/list" + query).then(res => {
					this.couponList = res.body.data;
					this.query.page = res.body.pageNum;
					this.query.size = res.body.pageSize;
					this.query.total = res.body.total;
				})
				this.senddata.userId = id
				this.senddata.nickname = name
				this.senddata.telphone = telphone
			},
			//发送券
			sendCoupon() {
				this.senddata.couponId = this.radio
				let q = {
					userId: this.senddata.userId,
					nickName: this.senddata.nickname,
					telphone: this.senddata.telphone,
					couponId: this.senddata.couponId,
				}
				this.$http.post("dCoupon/directionPush", JSON.stringify(q)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("发送成功")
						this.senddata = [];
						this.dialog_tui = false;
					} else if (res.body.code == 1000) {
						this.$message.error(res.body.msg);
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			getlist(i) {
				if (i) {
					this.filter.page = 1
				}
				if (this.filter.latestConEndTime == "") {
					this.filter.latestConEndTime = ""
					this.latestConStartTime = ""
				}
				if (this.latestConStartTime == "") {
					this.filter.latestConEndTime = ""
					this.latestConStartTime = "null"
				}
				this.loading = true;
				this.$http.get("user/userList", {
					params: this.filter
				}, {
					emulateJSON: true
				}).then(function(res) {
					this.list = []
					if (res.body.code == 200) {
						if (res.body.data) {
							this.list = res.body.data
							this.filter.total = res.body.total
						}
					}
					this.loading = false;
				}, function(err) {
					this.$message.error("请求失败")
					this.loading = false;
				})
			},
			// 控制三个值是否禁用
			changeDiabale() {
				if ((this.filter.latestConStartTime == '' || this.filter.latestConStartTime == undefined) || (this.filter
						.latestConEndTime == '' || this.filter.latestConEndTime == undefined)) {
					this.disabled = true
				} else {
					this.disabled = false
				}
			},
			handleSizeChange(val) {
				this.filter.size = (val)
				this.getlist()
			},
			handleCurrentChange(val) {
				this.filter.page = (val)
				this.getlist()
			},
			handleClick(id) {
				console.log("进入事件")
			},
			goshow(id) {
				this.$router.push({
					path: '/udata_lists',
					query: {
						id: id
					}
				})
			},
			// 页码器
			handleSizeChange3(val) {
				this.juanfilter.size = val
				this.getjuan()
			},
			handleCurrentChange3(val) {
				this.juanfilter.page = val
				this.getjuan()
			},
			handleSizeChange2(val) {
				this.juanbfilter.size = val
				this.getjuan()
			},
			handleCurrentChange2(val) {
				this.juanbfilter.page = val
				this.getjuan()
			},
		}
	};
</script>
<style lang="less" scoped>
	// 标题
	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	//输入框列表
	.input_list {
		.input_one {
			display: flex;

			&:nth-child(n + 2) {
				margin-top: 20px;
			}

			.input_one_wen {
				padding-left: 10px;
				line-height: 30px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #3e3e3e;
				width: 110px;
			}

			.input_one_wen01 {
				margin-left: 10px;
				padding-left: 10px;
				line-height: 30px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #3e3e3e;
				width: 80px;
			}
		}
	}

	// 页码器
	.pagescg {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 表格
	.usertable {
		width: 100%;
		margin-top: 20px;

		.table_title {
			margin-bottom: 8px;
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #c9c9c9;
			width: 100%;
			text-align: right;
		}
	}

	.tablie_select {
		margin-top: 10px;
		display: flex;

		div {
			line-height: 30px;
		}
	}

	.nolabel {
		padding-bottom: 25px;

		p {
			line-height: 2;
			margin-top: -15px;
			text-align: center;
			font-size: 20px;
			color: #999999;
		}
	}

	send {
		display: flex;
		width: 100%;
		padding-left: 10%;
		padding-right: 10%;
		box-sizing: border-box;
		margin-top: 10px;
	}
</style>